import { render, staticRenderFns } from "./m-our-services.vue?vue&type=template&id=571313d6&scoped=true"
import script from "./m-our-services.vue?vue&type=script&lang=js"
export * from "./m-our-services.vue?vue&type=script&lang=js"
import style0 from "./m-our-services.vue?vue&type=style&index=0&id=571313d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571313d6",
  null
  
)

export default component.exports